import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";
import {
  SIDEBAR_DRAWER_SIZE
} from "./chunk-65W2CFPO.mjs";

// src/container.tsx
import MUIContainer from "@mui/material/Container";
import { jsx } from "react/jsx-runtime";
function LayoutContainer({ children, ...rest }) {
  const { sidebar, variant } = useLayoutContext();
  const offset = sidebar.isCollapsed ? SIDEBAR_DRAWER_SIZE.collapsed : SIDEBAR_DRAWER_SIZE.lg;
  const isSidebarVisible = variant === "customer";
  return /* @__PURE__ */ jsx(
    MUIContainer,
    {
      disableGutters: true,
      maxWidth: false,
      ...rest,
      sx: [
        {
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          ...isSidebarVisible && {
            width: { lg: `calc(100% - ${offset})` },
            ml: { lg: offset }
          }
        },
        ...Array.isArray(rest.sx) ? rest.sx : [rest.sx]
      ],
      children
    }
  );
}

export {
  LayoutContainer
};
